import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import SpecUpdate from './views/SpecUpdate.vue';
import BatchEntry from './views/BatchEntry.vue';
import SdsUpdate from './views/SdsUpdate.vue';
import Example from './views/Example.vue';
import CustomerInfo from './views/CustomerInfo.vue';
import SendUpdate from './views/SendUpdate.vue';
import Results from './views/Results.vue';
import Parameters from './views/Parameters.vue';
import Print from './views/Print.vue';
import Login from './views/Login.vue';
import isAuthenticated from './services';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/specupdate',
      name: 'specupdate',
      component: SpecUpdate,
    },
    {
      path: '/batchentry',
      name: 'batchentry',
      component: BatchEntry,
    },
    {
      path: '/sdsupdate',
      name: 'sdsupdate',
      component: SdsUpdate,
    },
    {
      path: '/example',
      name: 'example',
      component: Example,
    },
    {
      path: '/customer',
      name: 'customer',
      component: CustomerInfo,
    },
    {
      path: '/sendupdate',
      name: 'sendupdate',
      component: SendUpdate,
    },
    {
      path: '/results',
      name: 'results',
      component: Results,
    },
    {
      path: '/parameters',
      name: 'parameters',
      component: Parameters,
    },
    {
      path: '/print',
      name: 'print',
      component: Print,
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const toLogin = to.path === '/login';
  const authenticated = await isAuthenticated();

  if (!authenticated) {
    if (!toLogin) {
      // If not authenticated and not on the login page, redirect to login
      next({ path: '/login' });
    } else {
      // Continue to the login page
      next();
    }
  } else if (toLogin) {
    // If authenticated and trying to access login page, redirect to home
    next({ path: '/' });
  } else {
    // Continue to the requested page
    next();
  }
});

export default router;
